export class HttpLogExporter {
    constructor(private endpoint: string) {}

    async export(
        logs: any[],
        resultCallback: (result: { code: number; error?: Error }) => void
    ) {
        try {
            await fetch(this.endpoint, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(logs),
                keepalive: true,
            });
            resultCallback({ code: 0 });
        } catch (err) {
            resultCallback({ code: 1, error: err instanceof Error ? err : new Error(String(err)) });
        }
    }

    shutdown() {
        return Promise.resolve();
    }
}
